<template>
  <div
    v-ripple="clickable"
    class="flex flex-center card-item relative-position"
    :class="{'selected': selected, 'invalid': invalid, 'cursor-pointer': clickable}"
    @click="$emit('select', account ? account.id : null)"
  >
    <q-icon
      :name="!invalid ? 'done' : 'mdi-exclamation-thick'"
      class="checked"
    />
    <div class="q-pl-sm q-pr-md">
      <i
        class="pf"
        :class="cardClass"
      />
    </div>
    <div class="flex-auto q-pr-xl">
      <div class="text-subtitle2 q-pt-sm">
        Ending in {{ account.last4 }}
      </div>
      <div class="q-pb-sm">
        <small>{{ account.brand }}</small>
        <small v-if="account.exp_year && account.exp_month"> - {{ String(account.exp_month).padStart(2, '0') }}/{{ account.exp_year }}</small>
      </div>
    </div>

    <div
      v-if="deletable && !account.default"
      class="q-pl-sm q-pr-lg"
    >
      <q-btn
        color="red-8"
        round
        flat
        dense
        icon="close"
        @click="deleteCard"
      >
        <q-tooltip>Delete</q-tooltip>
      </q-btn>
    </div>
    <slot />
    <q-inner-loading :showing="loading">
      <loading-spinner
        component="q-spinner-dots"
        color="red-8"
      />
    </q-inner-loading>
  </div>
</template>

<script>
export default {
  props: {
    account: {
      type: Object,
      required: true
    },
    index: {
      required: true,
      type: Number
    },
    selected: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    }
  },
  emits: ['select', 'deleting', 'delete'],
  data () {
    return {
      loading: false,
      cardIcons: {
        visa: 'pf-visa',
        mastercard: 'pf-mastercard',
        amex: 'pf-american-express',
        unknown: 'pf-credit-card'
      }
    }
  },
  computed: {
    cardClass () {
      const card = this.account.brand.toLowerCase()
      if (card in this.cardIcons) {
        return this.cardIcons[card]
      }
      return this.cardIcons.unknown
    }
  },
  methods: {
    async deleteCard () {
      this.loading = true
      this.$emit('deleting', true)
      const { status } = await this.$post('v1/cards/delete', {
        card_id: this.account.id
      })
      this.$emit('deleting', false)
      this.loading = false
      if (status === 'success') {
        this.$emit('delete', this.index)
      }
    }
  }
}
</script>

<style scoped lang="scss" src="src/css/components/payment.scss" />
